import {GetVehicleApiResponse} from '@dms/api/vehicle';
import {VehicleCustomFields, UmweltplaketteEnum} from '@dms/shared';

import {getCustomFieldValue} from './getCustomFieldValue';

/**
 * Extract and convert Umweltplakette value to proper enum type
 *
 * @param customFields - Array of custom fields from API response
 * @returns The umweltplakette enum value or null if not found
 *
 * @example
 * ```typescript
 * const badge = getUmweltplaketteValue(vehicle.customFields);
 * // Returns: UmweltplaketteEnum.green or null
 * ```
 */
export const getUmweltplaketteValue = (
  customFields: GetVehicleApiResponse['customFields']
): UmweltplaketteEnum | null => {
  const value = getCustomFieldValue(customFields, VehicleCustomFields.umweltplakette.definitionId);
  return value ? (value as UmweltplaketteEnum) : null;
};
